import * as React from 'react';
import { createElement } from 'react';
import { Slider } from '@alifd/next';
import 'swiper/swiper.scss';
import './index.scss';
import { noticeListAuthorityPage } from '../../http/api';
export default class Notice extends React.PureComponent {
    state;
    props;
    setState;
    constructor(props) {
        super(props);
        this.state = {
            noticeData: []
        };
    }
    componentDidMount() {
        this.noticeListAuthorityPageRequest(this.props);
    }
    componentWillReceiveProps(nextProps) {
        if (nextProps.limit !== this.props.limit)
            this.noticeListAuthorityPageRequest(nextProps);
    }
    noticeListAuthorityPageRequest = (nextProps) => {
        const params = {
            pageNum: 1,
            pageSize: nextProps.limit,
        };
        noticeListAuthorityPage(params).then(({ data, resultCode }) => {
            if (resultCode === 200) {
                this.setState({
                    noticeData: data.list
                });
            }
        });
    };
    render() {
        return (createElement("div", { ...this.props, className: "notice-swiper", style: { ...this.props.style } },
            createElement(Slider, { slideDirection: "ver", dots: false, arrows: false, className: "ver-slick", autoplay: true, autoplaySpeed: 2500 }, this.state.noticeData && this.state.noticeData.map((item, index) => (createElement("div", { key: index, className: "custom-slider" }, item.noticeTitle))))));
    }
}
;
